import api from "../../../config/api";
import { weatherFromDataRequest, weatherFromDataSuccess, weatherFromDataFailure, singleWeatherFromDataRequest, singleWeatherFromDataSuccess, singleWeatherFromDataFailure } from "../slice/tripWeatherInfoSlice";
import { put, takeLatest, call } from "redux-saga/effects";
import { config } from "../../../config/global";
const fetchWeatherData = async payload => {
  const FETCH_API_URL = config.TRIP_WEATHER_INFO + payload;
  const data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Content-Type": "application/json"
    },
    loader: false
  };
  const response = await api.get(FETCH_API_URL, data);
  return response;
};
function* getWeatherClassData(action) {
  try {
    const {
      payload
    } = action;
    const results = [];
    for (const data of payload) {
      const response = yield call(fetchWeatherData, data);
      results?.push(response?.data);
    }
    yield put(weatherFromDataSuccess(results));
  } catch (error) {
    yield put(weatherFromDataFailure(error));
  }
}
function* getSingleWeatherClassData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(fetchWeatherData, payload);
    yield put(singleWeatherFromDataSuccess(response?.data));
  } catch (error) {
    yield put(singleWeatherFromDataFailure(error));
  }
}
export function* watchweatherinformationdata() {
  yield takeLatest(weatherFromDataRequest.type, getWeatherClassData);
}
export function* watchsingleweatherinformationdata() {
  yield takeLatest(singleWeatherFromDataRequest.type, getSingleWeatherClassData);
}